import { render, staticRenderFns } from "./collectionAssociationChargeDialog.vue?vue&type=template&id=3d33f862&"
import script from "./collectionAssociationChargeDialog.vue?vue&type=script&lang=js&"
export * from "./collectionAssociationChargeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d33f862')) {
      api.createRecord('3d33f862', component.options)
    } else {
      api.reload('3d33f862', component.options)
    }
    module.hot.accept("./collectionAssociationChargeDialog.vue?vue&type=template&id=3d33f862&", function () {
      api.rerender('3d33f862', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Act/collectionAssociationChargeDialog.vue"
export default component.exports